import React from 'react';
import {
  Route,
  withRouter
} from 'react-router-dom';

import { LOGIN_ROUTE, BADGING_LOGIN_ROUTE, ADP, ADP_APPLICATION, EMAIL_LOGIN_ROUTE } from '../constants/RouterConstants';

import Login from './authentication/Login';
import MailLogin from './authentication/MailLogin';
import BadgingLogin from './Badging/authentication/BadgingLogin';
import AdpLogin from './PermitManagement/ADP/authentication/AdpLogin';


const AuthLayout = () => (
  <>
    <Route exact path={LOGIN_ROUTE} component={Login} />
    <Route exact path={EMAIL_LOGIN_ROUTE} component={MailLogin} />
    <Route exact path={BADGING_LOGIN_ROUTE} component={BadgingLogin} />
    <Route exact path={ADP} component={AdpLogin} />
    <Route exact path={ADP_APPLICATION} component={AdpLogin} />
  </>
);

export default withRouter(AuthLayout);
